import React, { useState, useEffect, useRef } from "react";
import { projectURL } from "./utils/mockdata";
import PostSound from "./audio/Post.wav";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';

const CreatePost = ({ onPostCreated }) => {
  const [newPost, setNewPost] = useState('');
  const postAudioRef = useRef(null);

  useEffect(() => {
    postAudioRef.current = new Audio(PostSound);
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    const userId = sessionStorage.getItem("loggedUserId");

    const dataInput = {
      post: newPost,
      created_by: userId
    };

    const postPath = projectURL + "posts/create";

    try {
      fetch(postPath, {
        headers: {
          "Content-Type": "application/json"
        },
        method: 'POST',
        body: JSON.stringify(dataInput),
      }).then(res => {
        setNewPost('');
        onPostCreated();
        postAudioRef.current.play();
      });
    } catch (error) {
      console.error("error", error);
    }
  };

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      // [{ 'size': ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
      ['link', 'image', 'video'],
      ['blockquote'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'font': [] }],
      [{ 'align': [] }],
      ['clean']
    ],
  };

  const formats = [
    'header', 'size',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet', 'link', 'image', 'video', 'blockquote', 'size', 'color', 'background', 'font', 'align'
  ];


  return (
    <form onSubmit={onSubmit}>
      <div className="relative py-2 rounded-lg bg-gray-50 w-full max-w-4xl mx-auto">
        <ReactQuill
          theme="snow"
          modules={modules}
          formats={formats}
          value={newPost}
          onChange={setNewPost}
          className="border-2 border-gray-900"
          placeholder="Share us Your Thought..."
        />

        {/* Submit Button */}
        <button
          type="submit"
          className="absolute bottom-3 right-3 p-2 text-blue-600 rounded-full cursor-pointer bg-blue-100 hover:bg-blue-200"
        >
          <svg
            className="w-5 h-5 rotate-90"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 18 20"
          >
            <path d="m17.914 18.594-8-18a1 1 0 0 0-1.828 0l-8 18a1 1 0 0 0 1.157 1.376L8 18.281V9a1 1 0 0 1 2 0v9.281l6.758 1.689a1 1 0 0 0 1.156-1.376Z" />
          </svg>
          <span className="sr-only">Send Post</span>
        </button>
      </div>

      {/* Custom CSS for multi-line height */}
      <style jsx>{`
        .ql-editor {
          min-height: 150px;
          max-height: 150px;
          overflow-y: auto;
          overflow-x: hidden;
        }
      `}</style>
    </form>
  );
};

export default CreatePost;
